module.exports = __webpack_public_path__ + "static/media/cart-icon-on-cream.7b4d0b0f.svg";